import { MenuListParams } from "../../../api/services/client/models";
import { searchSectionSiteCoreKeys } from "../siteCore/SiteCoreKeys";

export const ProjectSearchFormKey = {
  projectName: "projectName",
  projectNameFilter: "projectNameFilter",
  projectKey: "projectKey",
  projectKeyFilter: "projectKeyFilter",
  clientName: "clientName",
  clientNameFilter: "clientNameFilter",
  clientCode: "clientCode",
  clientCodeFilter: "clientCodeFilter",
  productLines: "productLines",
  productManagers: "productManagers",
  projectStatus: "projectStatus",
  participantName: "participantName",
  participantNameFilter: "participantNameFilter",
} as const;

export interface ProjectSearchFormProps {
  projectName: string;
  projectNameFilter: string;
  projectKey: string;
  projectKeyFilter: string;
  clientName: string;
  clientNameFilter: string;
  clientCode: string;
  clientCodeFilter: string;
  productLines: string[];
  productManagers: string[];
  projectStatus: string;
  participantName: string;
  participantNameFilter: string;
}

export const ProjectSearchResultFormKey = {
  projectName: "projectName",
  projectKeyNumber: "projectKeyNumber",
  clientName: "clientName",
  projectStatus: "projectStatus",
  productLine: "productLine",
  numberOfPrograms: "numberOfPrograms",
  projectManager: "projectManager",
  billingOffice: "billingOffice",
  salesOffice: "salesOffice",
  projectFee: "projectFee",
  poNumber: "poNumber",
  createdDate: "createdDate",
} as const;

export interface ProjectSearchResultRowValue {
  [ProjectSearchResultFormKey.projectName]: string;
  [ProjectSearchResultFormKey.projectKeyNumber]: string;
  [ProjectSearchResultFormKey.clientName]: string;
  [ProjectSearchResultFormKey.projectStatus]: string;
  [ProjectSearchResultFormKey.productLine]: string;
  [ProjectSearchResultFormKey.numberOfPrograms]: string;
  [ProjectSearchResultFormKey.projectManager]: string;
  [ProjectSearchResultFormKey.billingOffice]: string;
  [ProjectSearchResultFormKey.salesOffice]: string;
  [ProjectSearchResultFormKey.projectFee]: string;
  [ProjectSearchResultFormKey.poNumber]: string;
  [ProjectSearchResultFormKey.createdDate]: string;
}

export type DropdownFilterKey =
  | typeof ProjectSearchResultFormKey.projectStatus
  | typeof ProjectSearchResultFormKey.productLine
  | typeof ProjectSearchResultFormKey.billingOffice
  | typeof ProjectSearchResultFormKey.salesOffice;

export const ProjectSearchSaveFilterFormKey = {
  filterName: "filterName",
} as const;

export interface FilterProps {
  fieldName: string;
  fieldValue: string | string[];
  operatorId?: string;
  savedSearchFilterDataType?: number;
}

export interface ProjectSearchState {
  showModal: boolean;
  showMultipleDeleteModal: boolean;
  isSearchClick: boolean;
  isOpenSaveFilterModal: boolean;
  showLimitExceededAlert: boolean;
  filtersData: FilterProps[];
  showSavedFilter: boolean;
  filterToDelete: MenuListParams;
  preloadFilter: boolean;
  isMaxFilterReached: boolean;
  preloadFilterValuesProject: {
    id: string;
    name: string;
    filters: FilterProps[];
  };
}

export const PROJECT_SEARCH_FORM_DEFAULT_VALUES = {
  [ProjectSearchFormKey.projectName]: "",
  [ProjectSearchFormKey.projectNameFilter]: searchSectionSiteCoreKeys.contains,
  [ProjectSearchFormKey.projectKey]: "",
  [ProjectSearchFormKey.projectKeyFilter]: searchSectionSiteCoreKeys.contains,
  [ProjectSearchFormKey.clientName]: "",
  [ProjectSearchFormKey.clientNameFilter]: searchSectionSiteCoreKeys.contains,
  [ProjectSearchFormKey.clientCode]: "",
  [ProjectSearchFormKey.clientCodeFilter]: searchSectionSiteCoreKeys.contains,
  [ProjectSearchFormKey.productLines]: [],
  [ProjectSearchFormKey.productManagers]: [],
  [ProjectSearchFormKey.projectStatus]: "",
  [ProjectSearchFormKey.participantName]: "",
  [ProjectSearchFormKey.participantNameFilter]:
    searchSectionSiteCoreKeys.contains,
};
